import { render, staticRenderFns } from "./BasesComponent.vue?vue&type=template&id=c4896270"
import script from "./BasesComponent.vue?vue&type=script&lang=js"
export * from "./BasesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports